import { render, staticRenderFns } from "./consentToContinueQuote.vue?vue&type=template&id=5d06e7d8&"
import script from "./consentToContinueQuote.vue?vue&type=script&lang=js&"
export * from "./consentToContinueQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports